import { useQuery } from "@tanstack/react-query";
import { api } from "../../helpers/api";
import Spinner from "../../components/Spinners";
import { useState } from "react";
import { BannerForm, ConfirmDelete } from "./BannerForm";
import { ReactComponent as Pencil } from "../../assets/icons/pencil.svg";
import { ReactComponent as Trash } from "../../assets/icons/trash.svg";
import { ReactComponent as Plus } from "../../assets/icons/plus-circle.svg";

const AddBanner = ({ onClick }) => {
  return (
    <button
      onClick={onClick}
      className="w-[300px] h-[200px] bg-[#def5e3]/50 rounded-xl border border-[#7ca974] flex justify-center items-center"
    >
      <Plus />
    </button>
  );
};

const BannerCard = ({
  banner,
  onDelete,
  onEdit,
}: {
  banner: any;
  onDelete: () => void;
  onEdit: () => void;
}) => {
  return (
    <div className="rounded-[12px] w-[300px] h-[200px] relative">
      <img
        src={banner.banner_image}
        alt="banner"
        className="w-full h-full rounded-[12px]"
      />
      <div className="absolute top-2 right-2">
        <button
          className="h-8 w-8 bg-white/60 rounded-md backdrop-blur-[14px] justify-center items-center gap-2.5 flex"
          onClick={onDelete}
        >
          <Trash />
        </button>
      </div>
      <div className="absolute top-12 right-2">
        <button
          className="h-8 w-8 bg-white/60 rounded-md backdrop-blur-[14px] justify-center items-center gap-2.5 flex"
          onClick={onEdit}
        >
          <Pencil />
        </button>
      </div>
    </div>
  );
};
export function Banners() {
  const [edit, setEdit] = useState<any>(null);
  const [create, setCreate] = useState<boolean>(false);
  const [deleteBanner, setDeleteBanner] = useState<any>(null);
  const { data, isLoading, refetch } = useQuery({
    queryKey: ["banners"],
    queryFn: () => api.getBanners(),
  });

  console.log(data);
  const banners = data?.data?.banner || [];
  console.log(banners);
  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-4 mb-2">
        <div className="flex flex-row justify-between">
          <h1 className="text-black text-2xl font-bold leading-[28.8px]">
            Banners
          </h1>
        </div>
        <p className="text-sm text-black poppins">
          These banners are displayed at the top of the feed screen.
        </p>
      </div>
      <div className="flex h-[calc(100vh-140px)] p-5 gap-5 bg-white rounded-[16px] flex-wrap">
        {isLoading ? (
          <div className="flex justify-center items-center w-full h-full [&>svg]:text-primary">
            <Spinner />
          </div>
        ) : (
          <>
            {banners.map((banner: any) => (
              <BannerCard
                key={banner?.id}
                banner={banner}
                onDelete={() => setDeleteBanner(banner)}
                onEdit={() => setEdit(banner)}
              />
            ))}
            <AddBanner onClick={() => setCreate(true)} />
          </>
        )}
      </div>
      {!!edit && (
        <BannerForm
          banner={edit}
          onUpdate={() => refetch()}
          onClose={() => setEdit(null)}
        />
      )}
      {!!create && (
        <BannerForm
          onUpdate={() => refetch()}
          onClose={() => setCreate(false)}
        />
      )}
      {!!deleteBanner && (
        <ConfirmDelete
          onClose={() => setDeleteBanner(null)}
          bannerId={deleteBanner?.id}
          refetch={refetch}
        />
      )}
    </div>
  );
}
